import Constants from '../Constants';

export default class DocumentPoint {
  private x: number;
  private y: number;
  private documentId: number;
  private clusterId: number;
  private meta: object;

  constructor(datapoint) {
    this.x = +datapoint['x'];
    this.y = +datapoint['y'];
    this.documentId = datapoint['id'];
    this.clusterId = datapoint['cluster_id'];
    this.meta = datapoint['meta'];
  }

  getUrls() {
    if (
      !this.meta['urls'] ||
      this.meta['urls'].length === 0 ||
      !this.meta['urls'][0]
    ) {
      return [Constants.documentPoint.defaultPicture];
    } else {
      return this.meta['urls'];
    }
  }

  getX() {
    return this.x;
  }

  getY() {
    return this.y;
  }

  getClusterId() {
    return this.clusterId;
  }

  getId() {
    return this.documentId;
  }

  hasUrls() {
    return this.meta['urls'] && this.meta['urls'].length > 0;
  }

  getLevel() {
    return this.meta['level'];
  }

  getTitle() {
    return this.meta['title'];
  }

  getText() {
    return this.meta['text'];
  }

  getSource() {
    return this.meta['source'];
  }

  getIdeaId() {
    return this.meta['idea_id'];
  }

  getSessionId() {
    return this.meta['session_id'];
  }
}
